import React, { Component } from 'react'
import Icon from 'srcReact/components/icons/Icon'
import { withTranslation } from 'react-i18next'
import FocusTrap from 'focus-trap-react'

class AlertContainer extends Component {
  render() {
    const { title, message, handleClose, show, t } = this.props
    return (
      message !== 'cancelTokenError' && (
        <FocusTrap>
          <div className={`alert-wrapper ${show ? 'show' : ''}}`} role='alert' aria-live='assertive' aria-atomic='true'>
            <div className='alert-wrapper__title'>
              <strong className='alert-wrapper__title--left'>
                <Icon name='warning' size='large24' styleModifier='alert-wrapper__title--icon' />
                {title}
              </strong>
              <button
                type='button'
                className='alert-wrapper__close close ml-2 mb-1'
                data-dismiss='toast'
                onClick={handleClose}>
                <Icon name='close' />
                <span className='sr-only'>{t('global.alert_close')}</span>
              </button>
            </div>
            {Array.isArray(message) ? (
              message.map((m) => <div className='alert-wrapper__message'>{m}</div>)
            ) : (
              <div className='alert-wrapper__message'>{message}</div>
            )}
          </div>
        </FocusTrap>
      )
    )
  }
}
const ExtendedComponent = withTranslation('common')(AlertContainer)

export { ExtendedComponent as AlertContainer }
